import { render, staticRenderFns } from "./xzqh.vue?vue&type=template&id=42f82571&scoped=true&"
import script from "./xzqh.vue?vue&type=script&lang=js&"
export * from "./xzqh.vue?vue&type=script&lang=js&"
import style0 from "./xzqh.vue?vue&type=style&index=0&id=42f82571&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f82571",
  null
  
)

export default component.exports